// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import Plus from "@steiner/XDL/Icons/Plus";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.container = {};

categoriesStyles.title = {
    variant: "h2",
};

categoriesStyles.categoryContainer = {
    gap: 32,
};

categoriesStyles.innerCategoryContainer = {
    gap: 16,
};

categoriesStyles.categoryNameLinkItem = {
    width: 12,
    css: css`
        justify-content: Center;
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        size: "14px",
        weight: fontConfig.weight.bold,
        css: css`
            text-align: left;
            ${ellipsis(3)};
        `,
    },
    css: css`
        width: 100%;
    `,
};

categoriesStyles.subCategoryItem = {
    width: 12,
};

categoriesStyles.subCategoryLink = {
    typographyProps: {
        size: "14px",
        css: css`
            ${ellipsis(3)}
        `,
    },
};

categoriesStyles.viewMoreLinkItem = {
    width: 12,
};

categoriesStyles.viewMoreLink = {
    icon: {
        iconProps: {
            size: 12,
            src: Plus,
        },
    },
    typographyProps: {
        size: "12px",
        css: css`
            text-align: center;
        `,
    },
};

categoriesStyles.categoryImageItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

categoriesStyles.categoryImageLink = {
    css: css`
        width: 145px;
        height: 145px;
        overflow: hidden;
    `,
};

categoriesStyles.categoryImage = {
    css: css`
        width: 145px;
        height: 145px;
        img {
            aspect-ratio: 1;
        }
    `,
};

categoriesStyles.categoryItemRow = {
    width: [12, 6, 4, 3, 2],
};
